/**
 * NO BROKEN PICTURE, EVER (règle de la fondatrice, 23/09/2026).
 *
 * Une image qui a épuisé ses tentatives ne doit pas laisser le carré barré du navigateur sur la page
 * d'un acheteur — c'est ce qu'une boutique dupliquée a montré sur chaque produit ce jour-là. À la place :
 * un cadre neutre avec un glyphe d'image, qui garde la forme de la mise en page et dit « pas de photo
 * ici » plutôt que « cette page est cassée ». Un seul dessin, partagé par le composant React et par le
 * moteur vanille, pour que les deux surfaces se ressemblent.
 */
export const BROKEN_IMAGE_PLACEHOLDER = 'data:image/svg+xml;utf8,' +
    encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">' +
        '<rect width="64" height="64" fill="#EEF0F4"/>' +
        '<path d="M18 42l9-11 7 8 5-6 9 9H18z" fill="#B7BDC9"/>' +
        '<circle cx="24" cy="24" r="4" fill="#B7BDC9"/>' +
        '</svg>');
/** La marque que porte une image remplacée — lisible par un test, par le CSS, par un veilleur. */
export const BROKEN_IMAGE_ATTR = 'data-aqx-img-broken';
/**
 * Remplacer une `<img>` tombée pour de bon par le cadre neutre. `srcset` part avec : il l'emporterait
 * sur le `src` de secours et redemanderait le fichier qui vient de rater.
 */
export function markBroken(image) {
    if (image.getAttribute(BROKEN_IMAGE_ATTR) === 'true')
        return;
    image.setAttribute(BROKEN_IMAGE_ATTR, 'true');
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    if (!image.getAttribute('alt'))
        image.setAttribute('alt', '');
    image.setAttribute('src', BROKEN_IMAGE_PLACEHOLDER);
}
//# sourceMappingURL=brokenImage.js.map